import { AuthLink } from '@common/enums/request.enums'
import { Token, User } from '@common/types/request.types'
import { auth, get } from '@common/utils/request.utils'
import { Route } from '@config/routes/routes.enums'

type AuthenticationApiRequests = {
	login: (route: Route) => Promise<string>
	fetchToken: () => Promise<User & Token>
	fetchRefresh: () => Promise<User & Token>
}

/**
 * Authentication api requests
 */
export const useAuthenticationApi = (): AuthenticationApiRequests => {
	const login = (route: Route) => get<string>(
		`?redirect_uri=/${route}`,
		{},
		AuthLink.LOG_IN
	)

	const fetchToken = () => auth<User & Token>(AuthLink.TOKEN)

	const fetchRefresh = () => auth<User & Token>(AuthLink.REFRESH)

	return {
		fetchRefresh,
		fetchToken,
		login
	}
}
